import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyPaymentGateway({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <filter
          x="-12.5%"
          y="-8.9%"
          width="125%"
          height="125%"
          filterUnits="objectBoundingBox"
          id="pic-empty-payment-gateway_svg__a"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <filter
          x="-12.5%"
          y="-8.9%"
          width="125%"
          height="125%"
          filterUnits="objectBoundingBox"
          id="pic-empty-payment-gateway_svg__c"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <filter
          x="-10.9%"
          y="-7.8%"
          width="121.9%"
          height="121.9%"
          filterUnits="objectBoundingBox"
          id="pic-empty-payment-gateway_svg__e"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <filter
          x="-13.5%"
          y="-9.6%"
          width="126.9%"
          height="126.9%"
          filterUnits="objectBoundingBox"
          id="pic-empty-payment-gateway_svg__g"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <circle id="pic-empty-payment-gateway_svg__b" cx={28} cy={28} r={28} />
        <circle id="pic-empty-payment-gateway_svg__d" cx={28} cy={28} r={28} />
        <circle id="pic-empty-payment-gateway_svg__f" cx={32} cy={32} r={32} />
        <circle id="pic-empty-payment-gateway_svg__h" cx={26} cy={26} r={26} />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h240v168H0z" />
        <path
          d="M174.9 147.5c-43.2 2.41-60.36 17.5-100.9 15.93-47.85-1.86-78.23-20.72-69.66-62.12C12.37 62.58 70 37 108 19c119.31-56.52 185.35 121.9 66.9 128.5z"
          fill="#E9EDFB"
        />
        <path
          d="M237.17 93.63l-.07 1.23c-1.83 26.2-19.68 49-58.7 52.4l-3.5.24c-9.75.39-18.12 1.62-25.88 3.24-15.75 3.09-28.3 7.47-42.6 10.22a166.6 166.6 0 01-28.82 2.56c-1.18-.01-2.38-.05-3.6-.1-47.3-1.83-77.54-20.28-69.93-60.7 1.03-3.7 2.29-7.6 3.8-11.72 88.23 56.48 156.07-54.9 229.3 2.63z"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <g transform="translate(58 20)">
          <use
            fill="#000"
            filter="url(#pic-empty-payment-gateway_svg__a)"
            xlinkHref="#pic-empty-payment-gateway_svg__b"
          />
          <use fill="#6C7EC9" xlinkHref="#pic-empty-payment-gateway_svg__b" />
        </g>
        <path
          d="M90.1 51a5.77 5.77 0 015.54 5.76v.41c0 1.14-.92 2.07-2.06 2.07H78.42a2.07 2.07 0 01-2.06-2.07v-.41c0-3.1 2.46-5.63 5.53-5.76L86 55.1zm1.38-7.2a5.55 5.55 0 11-10.68.08l4.63 1.39a2 2 0 001.14 0l4.9-1.47zm-6.43-6.75a2.93 2.93 0 011.75 0l10.54 2.11a.91.91 0 010 1.76L86.8 43.74c-.76.24-1.41.1-1.75 0l-7-1.9v4.96c.33.25.55.62.6 1.06V48a1.5 1.5 0 11-2.4-1.2v-5.45l-1.59-.43a.9.9 0 01-.11-1.71l.11-.05z"
          fill="#FFF"
        />
        <g transform="translate(103 100)">
          <use
            fill="#000"
            filter="url(#pic-empty-payment-gateway_svg__c)"
            xlinkHref="#pic-empty-payment-gateway_svg__d"
          />
          <use fill="#6C7EC9" xlinkHref="#pic-empty-payment-gateway_svg__d" />
        </g>
        <path
          d="M139.75 134.38a1 1 0 011 1v1.75a1 1 0 01-1 1h-17.5a1 1 0 01-1-1v-1.75a1 1 0 011-1h17.5zm-13.32-8.63v7.5h-2.56v-7.5h2.55zm5.84 0v7.5h-2.55v-7.5h2.55zm5.85 0v7.5h-2.55v-7.5h2.55zm-6.57-7.74l8.66 4.73c.96.52.56 1.88-.54 1.88h-17.34c-1.1 0-1.5-1.36-.54-1.88l8.66-4.73c.34-.18.76-.18 1.1 0z"
          fill="#FFF"
        />
        <g transform="translate(147 27)">
          <use
            fill="#000"
            filter="url(#pic-empty-payment-gateway_svg__e)"
            xlinkHref="#pic-empty-payment-gateway_svg__f"
          />
          <use fill="#FFF" xlinkHref="#pic-empty-payment-gateway_svg__f" />
        </g>
        <path
          d="M173.71 71.57a1.71 1.71 0 100-3.43 1.71 1.71 0 000 3.43zm12.26 0a1.71 1.71 0 100-3.43 1.71 1.71 0 000 3.43zm3.4-18.56c.45 0 .8.06 1.06.18.21.1.4.25.53.45.1.18.15.37.15.57 0 .18-.04.36-.09.53-.05.14-1.7 6.66-1.85 7.08a2.8 2.8 0 01-.79 1.36c-.31.25-.7.38-1.18.38h-13.88l.34 1.69h13.4c.77 0 1.17.33 1.17 1 0 .3-.08.59-.24.84-.15.23-.46.35-.9.35h-13.86c-.3.01-.58-.06-.82-.22a2 2 0 01-.55-.57 3.5 3.5 0 01-.35-.77 7.05 7.05 0 01-.2-.78l-2.2-13.37h-1.82a1.7 1.7 0 01-.8-.25 1.1 1.1 0 01-.43-.92c0-.42.05-.61.27-.82.22-.22.51-.32.89-.32h2.45c.33 0 .59.05.78.15.35.16.6.46.7.82l.13.42.1.55.1.72.14.93h17.75zm-11.84-.79l3.21-3.22c.38-.37.78-.56 1.23-.57.45 0 .86.18 1.23.55l3.23 3.24h-8.9z"
          fill="#56A"
          opacity={0.95}
        />
        <g transform="translate(24 83)">
          <use
            fill="#000"
            filter="url(#pic-empty-payment-gateway_svg__g)"
            xlinkHref="#pic-empty-payment-gateway_svg__h"
          />
          <use fill="#FFF" xlinkHref="#pic-empty-payment-gateway_svg__h" />
        </g>
        <path
          d="M49.73 104.43l-6.44 5.31v6.99c0 .3.25.56.56.56l3.92-.01c.3 0 .55-.25.55-.56v-3.35c0-.3.25-.55.56-.55h2.24c.3 0 .56.25.56.55v3.35a.56.56 0 00.55.56h3.92c.3 0 .56-.24.56-.55v-7l-6.44-5.3a.43.43 0 00-.54 0zm7.26 1.2v-4.84a.42.42 0 00-.42-.42H54.6a.42.42 0 00-.42.42v2.54l-3.13-2.57a1.67 1.67 0 00-2.13 0l-8.84 7.28a.42.42 0 00-.06.6l.9 1.07a.42.42 0 00.59.06l8.21-6.77a.43.43 0 01.54 0l8.22 6.77a.42.42 0 00.59-.05l.89-1.09a.42.42 0 00-.06-.59l-2.92-2.4z"
          fill="#56A"
          opacity={0.9}
        />
        <g opacity={0.8} fill="#666">
          <path
            d="M120.4 42.67c.63-.15 1.26-.28 1.9-.39l-.34-1.97c-.67.12-1.34.25-2.02.4l.45 1.96zm3.83-.67c.64-.07 1.29-.13 1.93-.17l-.12-2c-.68.05-1.36.1-2.05.19l.24 1.98zm3.89-.23c.64 0 1.3.02 1.94.05l.1-2c-.68-.03-1.36-.05-2.05-.05v2zm3.87.21c.65.08 1.29.17 1.93.27l.33-1.97c-.68-.11-1.36-.2-2.04-.28l-.22 1.98zm3.86.65c.63.14 1.26.3 1.89.48l.54-1.93c-.67-.18-1.33-.35-2-.5l-.43 1.95z"
            fillRule="nonzero"
          />
          <path d="M141.12 38.64l2.96 4.39a.5.5 0 01-.14.7l-4.38 2.95a.5.5 0 01-.77-.5l1.42-7.35a.5.5 0 01.9-.19z" />
        </g>
        <path
          d="M176.42 96.86c-.09.65-.2 1.29-.33 1.9l1.96.41c.14-.66.26-1.34.35-2.03l-1.98-.28zm-.79 3.78c-.18.62-.38 1.23-.6 1.82l1.87.7c.24-.64.46-1.3.66-1.97l-1.93-.55zm-1.36 3.6c-.28.58-.58 1.14-.91 1.68l1.7 1.03c.37-.59.7-1.2 1-1.84l-1.8-.87zm-1.98 3.25c-.38.5-.78 1-1.21 1.46l1.47 1.35c.48-.51.92-1.05 1.34-1.61l-1.6-1.2zm-2.6 2.82c-.47.42-.97.82-1.49 1.2l1.18 1.61a22.3 22.3 0 001.63-1.3l-1.32-1.5zm-.96 6.72l-5.23-.83a.5.5 0 01-.42-.57l.83-5.23a.5.5 0 01.9-.21l4.4 6.05a.5.5 0 01-.48.79zM96.1 128c-.65.1-1.29.15-1.92.2l.12 1.99c.68-.04 1.37-.1 2.06-.2l-.26-1.98zm-3.84.23c-.65-.01-1.28-.05-1.9-.12l-.22 2c.68.07 1.37.1 2.08.12l.04-2zm-3.82-.42a17.5 17.5 0 01-1.83-.48l-.61 1.9c.66.22 1.34.4 2.03.54l.41-1.96zm-3.6-1.15c-.58-.26-1.14-.54-1.68-.86l-1 1.73c.6.35 1.23.67 1.87.96l.81-1.83zm-6.05 2.54l-1.37-5.1a.5.5 0 01.35-.62l5.12-1.37a.5.5 0 01.56.74l-3.74 6.48a.5.5 0 01-.92-.12z"
          opacity={0.8}
          fill="#666"
        />
      </g>
    </svg>
  );
}

SvgPicEmptyPaymentGateway.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyPaymentGateway.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyPaymentGateway svgRef={ref} {...props} />
));
export default ForwardRef;
